import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import { Desktop, TabletMobile } from "../../../common/Responsive";
import { useIntlTranslate } from "../../../hooks";
import { Icon } from "@sportal/cdk";

import "./WizardStep.scss";

const WizardStepMobile = ({ titleMobile }) => {
  return (
    <div className="mobile-wizard-step__title" aria-hidden="true">
      <FormattedMessage id={titleMobile} />
    </div>
  );
};

const WizardStepNotMobile = ({ title, isActive, isCompleted }) => {
  return (
    <div className="wizard-step__title" aria-hidden="true">
      <FormattedMessage id={title} />
      {isActive && (
        <div className="wizard-step__status">
          <FormattedMessage id="wizard_step_active" />
        </div>
      )}
      {isCompleted && (
        <div className="wizard-step__status">
          <FormattedMessage id="wizard_step_completed" />
        </div>
      )}
    </div>
  );
};

export function WizardStep({
  stepNumber,
  title,
  titleMobile,
  isActive,
  isCompleted,
  ariaLabel,
}) {
  const wizardStepClasses = classnames("wizard-step", {
    "wizard-step--active": isActive,
    "wizard-step--disabled": !isActive && !isCompleted,
    "wizard-step--completed": isCompleted,
  });
  const translate = useIntlTranslate();
  const stepAriaLabel = translate(ariaLabel);
  const stepAriaStatusActive = translate(`aria_step_status_active`);
  const stepAriaStatusActiveCompleted = translate(`aria_step_status_completed`);
  const stepAriaStatus = isActive
    ? stepAriaStatusActive
    : isCompleted
    ? stepAriaStatusActiveCompleted
    : "";

  return (
    <li
      className={wizardStepClasses}
      aria-label={translate("aria_wizard_steps_item", {
        stepNumber,
        ariaLabel: stepAriaLabel,
        stepStatus: stepAriaStatus,
      })}
    >
      <span className="round-tab" aria-hidden="true">
        {isCompleted ? (
          <Icon icon="fa-solid fa-check completed-icon" />
        ) : isActive ? (
          <Icon icon="fa-regular fa-pencil active-icon" />
        ) : (
          stepNumber
        )}
      </span>
      <Desktop>
        <WizardStepNotMobile
          title={title}
          isActive={isActive}
          isCompleted={isCompleted}
        />
      </Desktop>
      <TabletMobile>
        <WizardStepMobile titleMobile={titleMobile} />
      </TabletMobile>
    </li>
  );
}

WizardStep.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  titleMobile: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};
